"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocaleFromCookie = void 0;
const cookie_1 = require("cookie");
const constants_1 = require("./constants");
const utils_1 = require("./utils");
const getLocaleFromCookie = (cookie) => {
    const cookies = (0, cookie_1.parse)(cookie);
    return getValidLocale(cookies[constants_1.LANG_PARAM]) || getValidLocale(getEblangLocale(cookies[constants_1.EBLANG_PARAM]));
};
exports.getLocaleFromCookie = getLocaleFromCookie;
const getValidLocale = (locale) => {
    return locale && (0, utils_1.isSupportedLocale)(locale) ? (0, utils_1.getLocale)(locale) : null;
};
const getEblangLocale = (eblangCookie) => {
    if (!eblangCookie)
        return null;
    try {
        const decoded = decodeURIComponent(eblangCookie);
        const urlSearchParams = new URLSearchParams(decoded);
        return urlSearchParams.get("lo") || null;
    }
    catch (error) {
        console.error("Error parsing eblangCookie:", error);
        return null;
    }
};
//# sourceMappingURL=cookies.js.map